<div id="forDiv">
  <a [style.border-color]="borderColor" [style.background-color]="color" [style.color]="textColor" class="link_boxOval">
    <h2 [style.color]="textColor" class="title">
      {{label}}
    </h2>
    <h2 [style.color]="textColor" class="name">
      {{name}}
    </h2>
  </a>
</div>